module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/icons/sparks-32.png"+" 32w",
        images: [{path: __webpack_public_path__ + "assets/images/icons/sparks-32.png",width: 32,height: 32}],
        src: __webpack_public_path__ + "assets/images/icons/sparks-32.png",
        toString: function(){return __webpack_public_path__ + "assets/images/icons/sparks-32.png"},
        
        width: 32,
        height: 32
      }